import { useSelector } from 'react-redux';
import {
  selectAssessmentsMode,
  selectAssessmentsTenantId,
  selectSurveyEventId,
} from '../assessmentsAuthSlice';
import { useAssessmentsPaths } from './useAssessmentsPaths';

/**
 * Identifiers assessments calls depend on. Assessments opened from the checklist carry them in the
 * store; the campaign flow keeps reading them from the URL.
 */
export const useAssessmentsParams = () => {
  const mode = useSelector(selectAssessmentsMode);
  const storeTenantId = useSelector(selectAssessmentsTenantId);
  const storeSurveyEventId = useSelector(selectSurveyEventId);
  const { tenantId: urlTenantId, surveyEventId: urlSurveyEventId } = useAssessmentsPaths();

  const isAuthenticated = mode === 'authenticated';

  return {
    tenantId: isAuthenticated ? storeTenantId : urlTenantId,
    surveyEventId: isAuthenticated ? storeSurveyEventId : urlSurveyEventId,
  };
};
